import { ProtectedComponent } from '@components'

import { ModuleLayout } from '@billy/design-system'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'

import { useBookkeepingBankAccounts } from '@features/accounts/hooks/useBookkeepingBankAccounts'
import { BankUrlParams } from '@features/accounts/types/bankUrlParams'
import { ConnectBankContent } from '@features/bankAccounts/elements/ConnectBankContent'
import { BankView } from '@features/bankAccounts/elements/ConnectBankContent/enums/bankView'
import { BankIntegrationContextProvider } from '@features/openBanking/contexts/bankIntegrationContext'
import { BankConnectionStatusActions } from '@features/openBanking/elements/BankConnectionStatusActions'
import { BankReconciliationAccountSelect } from '@features/reconciliation/elements/BankReconciliationAccountSelect'
import { UiSource } from '@features/reconciliation/enums'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { Scope } from '../../../../enums/scope'
import * as Styled from './styles'

export const BankConnectionEmpty = () => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()
  const { bookkeepingBankAccounts } = useBookkeepingBankAccounts()
  const { bankAccountId } = useParams<BankUrlParams>()

  const hasOnlyOneAccount = bookkeepingBankAccounts?.length === 1

  return (
    <ModuleLayout
      title={
        hasOnlyOneAccount || !bankAccountId ? (
          t('bankreconciliation.connect_bank.title')
        ) : (
          <BankReconciliationAccountSelect selectedId={bankAccountId} withConnectNewAccountAction={false} />
        )
      }
    >
      <Styled.BankConnectionEmptyModuleContainer>
        <ProtectedComponent scopes={Scope.BankSyncWrite}>
          <ConnectBankContent bankView={BankView.BankReconciliation} uiSource={UiSource.OldReconEmptyState} />
        </ProtectedComponent>
      </Styled.BankConnectionEmptyModuleContainer>

      <BankIntegrationContextProvider account={bankAccountId} organizationId={organization?.id ?? ''}>
        <BankConnectionStatusActions />
      </BankIntegrationContextProvider>
    </ModuleLayout>
  )
}
